import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { Configuration } from '../config';

@Component({
    selector: 'replication-config',
    template: `<form #replicationConfigFrom="ngForm" class="compact">
<section class="form-block" style="margin-top:0px;margin-bottom:0px;">
<label style="font-size:14px;font-weight:600;" *ngIf="showSubTitle">{{'CONFIG.REPLICATION' | translate}}</label>
<div class="form-group">
  <label for="verifyRemoteCert">{{'CONFIG.VERIFY_REMOTE_CERT' | translate }}</label>
    <clr-checkbox name="verifyRemoteCert" id="verifyRemoteCert" [(ngModel)]="replicationConfig.verify_remote_cert.value" [disabled]="!editable">
      <a href="javascript:void(0)" role="tooltip" aria-haspopup="true" class="tooltip tooltip-lg tooltip-top-right" style="top:-8px;">
        <clr-icon shape="info-circle" class="info-tips-icon" size="24"></clr-icon>
        <span class="tooltip-content">{{'CONFIG.TOOLTIP.VERIFY_REMOTE_CERT' | translate }}</span>
      </a>
     </clr-checkbox>
</div>
</section>
</form>
`,
    styles: ['./replication-config.component.scss', '../registry-config.component.scss']
})
export class ReplicationConfigComponent {
    config: Configuration;
    @Output() configChange: EventEmitter<Configuration> = new EventEmitter<Configuration>();

    @Input()
    get replicationConfig(): Configuration {
        return this.config;
    }
    set replicationConfig(cfg: Configuration) {
        this.config = cfg;
        this.configChange.emit(this.config);
    }

    @Input() showSubTitle: boolean = false;

    @ViewChild("replicationConfigFrom") replicationConfigForm: NgForm;

    get editable(): boolean {
        return this.replicationConfig &&
            this.replicationConfig.verify_remote_cert &&
            this.replicationConfig.verify_remote_cert.editable;
    }

    get isValid(): boolean {
        return this.replicationConfigForm && this.replicationConfigForm.valid;
    }
}
